export default "__VITE_PUBLIC_ASSET__287322f9__"